<template>
    <div class="result-challenge-select-user-username">
        <svg v-if="showArtValid" class="result-challenge-select-user-username__art" width="27" height="39" viewBox="0 0 27 39" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 0h2v34a1 1 0 11-2 0V0z" fill="#F5F5F5"/><circle cx="5" cy="34" r="3.5" stroke="#57C07A" stroke-width="3"/><g opacity=".5" clip-path="url(#prefix__clip0_850_5068)"><path d="M14.646 38.566a.606.606 0 01-.428-1.034l3.573-3.572-3.573-3.572a.606.606 0 01.856-.856l4 4a.606.606 0 010 .857l-4 4a.6.6 0 01-.428.177z" fill="#333"/></g><g opacity=".8" clip-path="url(#prefix__clip1_850_5068)"><path d="M21.646 38.566a.606.606 0 01-.428-1.034l3.573-3.572-3.573-3.572a.606.606 0 01.856-.856l4 4a.606.606 0 010 .857l-4 4a.6.6 0 01-.428.177z" fill="#333"/></g><defs><clipPath id="prefix__clip0_850_5068"><path fill="#fff" transform="translate(14 29)" d="M0 0h5.294v10H0z"/></clipPath><clipPath id="prefix__clip1_850_5068"><path fill="#fff" transform="translate(21 29)" d="M0 0h5.294v10H0z"/></clipPath></defs></svg>
        <svg v-if="showArtError" class="result-challenge-select-user-username__art" width="27" height="39" viewBox="0 0 27 39" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 0h2v34a1 1 0 11-2 0V0z" fill="#F5F5F5"/><circle cx="5" cy="34" r="3.5" stroke="#C05757" stroke-width="3"/><g opacity=".5" clip-path="url(#prefix__clip0_843_4933)"><path d="M14.646 38.566a.606.606 0 01-.428-1.034l3.573-3.572-3.573-3.572a.606.606 0 01.856-.856l4 4a.606.606 0 010 .857l-4 4a.6.6 0 01-.428.177z" fill="#333"/></g><g opacity=".8" clip-path="url(#prefix__clip1_843_4933)"><path d="M21.646 38.566a.606.606 0 01-.428-1.034l3.573-3.572-3.573-3.572a.606.606 0 01.856-.856l4 4a.606.606 0 010 .857l-4 4a.6.6 0 01-.428.177z" fill="#333"/></g><defs><clipPath id="prefix__clip0_843_4933"><path fill="#fff" transform="translate(14 29)" d="M0 0h5.294v10H0z"/></clipPath><clipPath id="prefix__clip1_843_4933"><path fill="#fff" transform="translate(21 29)" d="M0 0h5.294v10H0z"/></clipPath></defs></svg>
        <span class="result-challenge-select-user-username__text">{{ resultText }}</span>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            errorInvOptions: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            showArtValid(){
                return this.$store.state.response.challengeSelectUser.searchedUserItems.length > 0 ? true : false;
            },

            showArtError(){
                return this.$store.state.response.challengeSelectUser.searchedUserItems.length === 0 ? true : false;
            },

            resultText(){
                let input = this.$store.state.input.challengeSelectUser.username;
                let searchedUserItems = this.$store.state.response.challengeSelectUser.searchedUserItems;
                if(this.errorInvOptions){
                    return 'girdiğin karakterler geçersiz.';
                }
                return `"${input}" için ${searchedUserItems.length} sonuç bulundu.`;
            }
        },
    };
</script>

<style scoped src="@/css/components/result-challenge-select-user-username.css"></style>